import type { BiometryResponse } from '~/utils/customer-register/Biometry'
import http from '~/services-v2/contract-formalization-api/contract-formalization-api.http'

export async function sendCustomerBiometry(projectId: string, orderId?: string) {
  const response = await http.post<BiometryResponse>('/v1/formalizations/', {
    project_id: projectId,
    contract_token_receipt_method: 'whatsapp',
    ...(orderId ? { order_id: orderId } : {}),
  })
  return response.data
}

export async function resendCustomerBiometry(projectId: string) {
  const response = await http.post<BiometryResponse>(`/v1/formalizations/resend/${projectId}`)
  return response.data
}

export async function cancelCustomerBiometry(projectId: string) {
  const response = await http.post<BiometryResponse>(`/v1/formalizations/cancel/${projectId}`)
  return response.data
}

export async function resendContractBiometry(projectId: string) {
  const response = await http.post<BiometryResponse>(`/v1/formalizations/${projectId}/contract/resend`)
  return response.data
}

export async function resendBiometryOnly(projectId: string) {
  const response = await http.post<BiometryResponse>(`/v1/formalizations/${projectId}/biometric/resend`)
  return response.data
}

export async function cancelContract(projectId: string) {
  const response = await http.put<BiometryResponse>(`/v1/formalizations/${projectId}/contract/cancel`)
  return response.data
}
